import React from "react";
import { QueryObserverResult } from "react-query";
import {
  COLOURS,
  MigrationSetImport,
  MigrationSetWithImports,
} from "../../shared";
import { Card } from "../card";
import { Tags } from "lucide-react";

interface CardMatterTagProps {
  currentMigrationSetId: number;
  data: { imports: MigrationSetImport[] } | undefined;
  cardsState: Record<string, any>;
  disableButtonAccess: boolean;
  refetchMigrationSet: () => Promise<
    QueryObserverResult<MigrationSetWithImports, unknown>
  >;
}

export const CardMatterTag: React.FC<CardMatterTagProps> = ({
  currentMigrationSetId,
  data,
  cardsState,
  disableButtonAccess,
  refetchMigrationSet,
}) => {
  return (
    <Card
      image={
        <Tags
          color={COLOURS.cardIconColor}
          strokeWidth={2}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        />
      }
      importType="matterTag"
      templateKey="matterTagImport"
      fileName="matterTag.csv"
      migrationSetId={currentMigrationSetId}
      migrationSetImport={data?.imports.find(
        (i) => i.importType === "matterTag",
      )}
      headerText="Matter Tags"
      description="Can be used to add Tags to a Matter. If a provided tag name matches one already configured in the Smokeball account, it will be used; otherwise, a new one will be configured during the import."
      cardState={cardsState["matterTag"]}
      disableButtonAccess={disableButtonAccess}
      refetchMigrationSet={refetchMigrationSet}
    />
  );
};
